import  {getActiveDrugs} from '../services/Api'
import React, { useState, useEffect } from "react";
import Empty from '../components/Empty'
import Loading from './LoadingIndicator'
function Drug(props){
    return(
      <h1 className='root-title' > {props.name}</h1>
    )
}

function ActiveDrugs(props) {

  const [loading, setLoading] = useState(true);
  const [empty, setEmpty] = useState(true);
  const [drugs, setDrugs] = useState([]);
  const patient = props.patient_id;
  async function  componentDidMount() {

    try {
      const response = await getActiveDrugs(patient);
      if(response.request.status === 200){
        const drugs = response.data.drugs;
        setLoading(false);
        if(drugs.length > 0){
          setDrugs(drugs);
          setEmpty(false)
        }
        
        
      }
    }catch (e) {
      setLoading(false);
      console.warn("ERROR", e);
      
    }
  }

  useEffect(componentDidMount, [])

  return (
    <React.Fragment>
      <ul className="drugs-list">
        <Loading working={loading}/>
        <Empty empty={empty}/>
        { Object.keys(drugs).map((item) => <li key={item} ><Drug name={drugs[item]} ></Drug></li>)}
        </ul>
    </React.Fragment>
  )
}


export default ActiveDrugs